import { Card, FormGroup, FormParagraph, SectionHeader } from '@ksyos/design-system';
import type { IAdminProcess } from '@common/interfaces';
import { ProcessTaskStatus } from '@common/enums';
import { ProcessStatusLabel } from '@frontend/components/elements/processStatus/ProcessStatusLabel';
import { PractitionerAndOrganization } from '@frontend/components/pages/processes/newAdminProcessDetails/PractitionerAndOrganization';

type TasksSectionProps = {
    process: IAdminProcess;
};

export function TasksSection({ process }: TasksSectionProps) {
    if (process.tasks.length === 0) {
        return null;
    }

    const tasks = process.tasks.filter(
        (processTask) =>
            processTask.status === ProcessTaskStatus.open || processTask.status === ProcessTaskStatus.inProgress
    );

    return (
        <>
            <SectionHeader title="Taken" />
            {tasks.map((task) => (
                <Card key={task.id}>
                    <Card.Header title={task.serviceWorkflowStep.name} />
                    <Card.Body>
                        <FormGroup label="Label">
                            <FormParagraph>
                                <ProcessStatusLabel
                                    label={task.type}
                                    status={task.status}
                                    type="taskPerformer"
                                />
                            </FormParagraph>
                        </FormGroup>
                        <FormGroup label="Status">
                            <FormParagraph>{task.status}</FormParagraph>
                        </FormGroup>
                        <FormGroup label="Technische naam">
                            <FormParagraph>{task.type}</FormParagraph>
                        </FormGroup>
                        <PractitionerAndOrganization
                            label="Toegewezen aan"
                            organization={task.performerOrganization}
                            practitioner={task.performerPractitioner}
                        />
                    </Card.Body>
                </Card>
            ))}
        </>
    );
}
